import { useEffect, useState } from "react";
import { storedLocale } from "../../../../Authentication/util";
import { useAppSelector } from "../../../../../store";
import { useGetLeadershipTripQualQuery } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI";
import type { LeadershipTripQualResponse } from "../../../../../services/AnnualIncomeDashboard/annualIncomeDashboardAPI.types";

const leadershipTripQualInitial: LeadershipTripQualResponse = {
  lsiTracking: {
    showLSI: false,
    routeId: "",
    status: "",
    requirements: [],
    isComingSoon: false,
  },
  callResults: [],
};

export const FetchLeadershipTripQualData = (period: string) => {
  const { user } = useAppSelector((state) => state.boot);
  const shellConfig = useAppSelector((state) => state.boot.shellConfig);

  const {
    data: payloadData,
    isFetching,
    isError,
    refetch,
  } = useGetLeadershipTripQualQuery({
    abo: user.abo,
    aff: user.aff,
    period,
    isoCountryCode: user.isoCountryCode,
    isoCurrencyCode: shellConfig.isoCurrencyCode,
    locale: storedLocale(),
  });

  const [isLoading, setIsLoading] = useState(true);
  const [errorStatus, setErrorStatus] = useState(false);
  const [leadershipTripQualData, setLeadershipTripQualData] =
    useState<LeadershipTripQualResponse>(leadershipTripQualInitial);

  useEffect(() => {
    setIsLoading(isFetching);
    setErrorStatus(isError);
    if (!isFetching && !isError && payloadData) {
      setLeadershipTripQualData(payloadData);
    }
  }, [isFetching, period, isError, payloadData]);

  return { isLoading, leadershipTripQualData, errorStatus, refetch };
};
